/* eslint-disable */
import React, { useRef, useEffect, useState } from 'react'

import { useField } from '@unform/core'
import classNames from 'classnames'

import { Input } from '../../input'
import { Componente, Erro } from './styles'
import { InputUnformProps } from './tipos'

export const MoedaInputUnform: React.FC<Omit<InputUnformProps, 'mascara'>> = ({
  name,
  semMargemAbaixo,
  onChange,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError
  } = useField(name || '')
  
  const [valor, definirValor] = useState(() => {
    if (!defaultValue) return ''
    // Formata o valor inicial se existir
    const valorNumerico = Number(defaultValue)
    if (valorNumerico === 0) return ''
    return valorNumerico.toFixed(2).replace('.', ',')
  })

  useEffect(() => {
    registerField<number>({
      name: fieldName,
      ref: inputRef.current,
      getValue({ inputElement }) {
        if (!inputElement?.value) return null

        return Number(
          inputElement.value
            .replace('R$', '')
            .replace(' ', '')
            .replace(/\./g, '')
            .replace(/&nbsp;/gi, '')
            .replace(',', '.')
        )
      },
      setValue(ref: any, value: number) {
        if (value === 0 || !value) {
          definirValor('')
        } else {
          const valorFormatado = value.toFixed(2).replace('.', ',')
          definirValor(valorFormatado)
        }
      },
      clearValue(ref: any) {
        ref.value = ''
        definirValor('')
      }
    })
  }, [fieldName, registerField])

  return (
    <Componente
      theme={{
        ComErro: !!error
      }}
      className={classNames({
        semMargemAbaixo
      })}
    >
      <Input
        {...rest}
        inputMode="numeric"
        name={name}
        onChange={e => {
          definirValor(e.target.value)
          onChange && onChange(e)
        }}
        value={valor}
        ref={inputRef}
        erro={!!error}
        className={classNames({
          error
        })}
        onKeyPress={clearError}
        moeda
      />
      <Erro id={`erro-${rest.id}`}>{error}</Erro>
    </Componente>
  )
}
